$(document).ready(function() {
    var delay=10;
    if (typeof slideDelayLeft ==='number'){
        delay=slideDelayLeft;
    }
    var leftElements = document.getElementsByClassName("bannersSlide-left");
    var leftButtons = document.getElementsByClassName("paginate-button-skyscrapper-left");

    if (leftElements.length > 0){
        displayBannerFirst(leftElements, leftButtons);
        bannersSlideshow(leftElements, leftButtons, delay);
    }
    var delay=10;
    if (typeof slideDelayRight ==='number'){
        delay=slideDelayRight;
    }
    var rightElements = document.getElementsByClassName("bannersSlide-right");
    var rightButtons = document.getElementsByClassName("paginate-button-skyscrapper-right");

    if (rightElements.length > 0){
        displayBannerFirst(rightElements, rightButtons);
        bannersSlideshow(rightElements, rightButtons, delay);
    }
    var delay=10;
    if (typeof slideDelayTeaser ==='number'){
        delay=slideDelayTeaser;
    }
    var teaserElements = document.getElementsByClassName("bannersSlide-teaser");
    var teaserButtons = document.getElementsByClassName("paginate-button-teaser");

    if (teaserElements.length > 0){
        displayBannerFirst(teaserElements, teaserButtons);
        bannersSlideshow(teaserElements, teaserButtons, delay);
    }
});

function bannersSlideshow(elements,buttons, seconds) {
    if(elements.length == 0){
        return;
    }
  var msTimeout = seconds*1000;
  setTimeout(function() {
    bannersSlideshow(elements,buttons,seconds);
}, msTimeout);

	var count = elements.length;
	for (var i = 0; i < count; i++) {
	    if (typeof buttons[i] !== 'undefined'){
		    buttons[i].classList.remove("selected");
		}
		if(elements[i].style.display == "block"){
			elements[i].style.display = "none";
			if (i < (count-1) ){
				var next = i+1;
			}
			else{
				var next = 0;
			}
			if (typeof buttons[i] !== 'undefined'){
			    buttons[next].classList.add("selected");
			}
			elements[next].style.display = "block";
			break;
		}
	}
}

function displayBannerFirst(elements,buttons){
    if (elements.length == 0){
        return;
    }
	for (var i = 0; i < elements.length; i++) {
		elements[i].style.display = "none";
		if (typeof buttons[i] !== 'undefined'){
		    buttons[i].classList.remove("selected");
		}
	}
	if (typeof elements[0] !== 'undefined'){
        elements[0].style.display = "block";
        if (typeof buttons[0] !== 'undefined'){
            buttons[0].classList.add("selected");
        }
	}
}

function displayBannersElementAt(position,elementsId,buttonsId)
{
    var elements = document.getElementsByClassName(elementsId);
    var buttons= document.getElementsByClassName(buttonsId);
    if(position<elements.length){
        for (var i = 0; i < elements.length; i++) {
            elements[i].style.display = "none";
            if (typeof buttons[i] !== 'undefined'){
                buttons[i].classList.remove("selected");
            }
        }
        elements[position].style.display = "block";
        if (typeof buttons[position] !== 'undefined'){
            buttons[position].classList.add("selected");
        }
    }
}
